/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DirectOAuth2AuthorizeResponse
 */
export interface DirectOAuth2AuthorizeResponse {
    /**
     * 
     * @type {string}
     * @memberof DirectOAuth2AuthorizeResponse
     */
    redirectUrl: string;
}

/**
 * Check if a given object implements the DirectOAuth2AuthorizeResponse interface.
 */
export function instanceOfDirectOAuth2AuthorizeResponse(value: object): value is DirectOAuth2AuthorizeResponse {
    if (!('redirectUrl' in value) || value['redirectUrl'] === undefined) return false;
    return true;
}

export function DirectOAuth2AuthorizeResponseFromJSON(json: any): DirectOAuth2AuthorizeResponse {
    return DirectOAuth2AuthorizeResponseFromJSONTyped(json, false);
}

export function DirectOAuth2AuthorizeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DirectOAuth2AuthorizeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'redirectUrl': json['redirectUrl'],
    };
}

export function DirectOAuth2AuthorizeResponseToJSON(json: any): DirectOAuth2AuthorizeResponse {
    return DirectOAuth2AuthorizeResponseToJSONTyped(json, false);
}

export function DirectOAuth2AuthorizeResponseToJSONTyped(value?: DirectOAuth2AuthorizeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'redirectUrl': value['redirectUrl'],
    };
}

